import { Component } from '@angular/core';
import { UserFormComponent, UserFormSaveResult } from '../../shared/user-form/user-form.component';

@Component({
    selector: 'app-signup',
    templateUrl: './signup.component.html',
    styleUrls: ['./signup.component.sass'],
    standalone: false
})
export class SignupComponent {
  status: 'idle' | UserFormSaveResult = 'idle';

  submit(userForm: UserFormComponent): void {
    this.status = 'idle';
    userForm.save();
  }

  onSaveResult(result: UserFormSaveResult): void {
    this.status = result;
  }
}
